import React from 'react';

import ReplenishmentStockSyncer from './ReplenishmentStockSyncer';
import ShippingStatusSyncer from './ShippingStatusSyncer';
import ArticleSyncer from './ArticleSyncer';

export const SyncManager = () => {

    return (
        <div className="animated fadeIn">
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <ReplenishmentStockSyncer />
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <ShippingStatusSyncer />
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <ArticleSyncer />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SyncManager;


// WEBPACK FOOTER //
// ./src/admin/sync/SyncManager.js